import { Component, Inject, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ActivatedRoute } from '@angular/router';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { selectAuthMessage, selectDealerProfile } from 'src/app/common/store/state/app.state';
import { DealerBasicData } from 'src/app/public/account/constants/dealer-basic-data';
import { Dealer } from 'src/app/public/account/models/dealer.model';
import { AppConstants } from 'src/app/public/common/constants/app-constants';
import { CarBasicData } from 'src/app/public/car/constants/car-basic-data';
import { CommonBasicData } from 'src/app/public/common/constants/common-basic-data';
import { GeneralBasicData } from 'src/app/public/common/constants/general-basic-data';

@Component({
    selector: 'dealer-edit',
    templateUrl: './dealer-edit.component.html',
    styleUrls: ['./dealer-edit.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})

export class DealerEditDialogComponent implements OnInit {
  
  myProfile$: Observable<Dealer>;
  authFeedback$: Observable<string>;

  formMessage: string = 'helloo';

  dealerTypes = DealerBasicData.dealerTypes;
  businessTypes = DealerBasicData.businessTypes;
  civilities = DealerBasicData.civilities;

  servicesTypes = CommonBasicData.serviceTypes;
  allMakes = CarBasicData.getMakesBD();
  countries = GeneralBasicData.getAllCountries();
  
  emailRegex = AppConstants.EMAIL_REGEX;
  phoneNumberRegex = AppConstants.PHONE_NUMBER_REGEX;


  constructor(
    
    public dialogRef: MatDialogRef<DealerEditDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: Dealer,

    private store: Store,  

    private route: ActivatedRoute) {
      this.myProfile$ = this.store.select(selectDealerProfile);
      this.authFeedback$ = store.select(selectAuthMessage);
    }
  
  ngOnInit(): void {
  
  } 

  onNoClick(): void {
    this.dialogRef.close();
  }

  getCitiesforCountry(countryCode: string): string[]{
    return GeneralBasicData.getAllCities([countryCode]);
  }

}